import { useCurrentPractitionerGlobalState } from './useCurrentPractitionerGlobalState';
import { CurrentPractitionerSetter } from './types';

export const useSetCurrentPractitionerGlobalState = (): CurrentPractitionerSetter => {
   const { setCurrentPractitioner } = useCurrentPractitionerGlobalState();
   return setCurrentPractitioner;
};
